import type { SVGProps } from 'react'

export default function PlayTriangle(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			width="25"
			height="24"
			viewBox="0 0 25 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M25 11.9956L5.08141 23.4956L5.08142 0.495622L25 11.9956Z"
				fill="currentColor"
			/>
		</svg>
	)
}
